// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__EnHmI","notes":"Notes_notes__3M2k6","note":"Notes_note__pRf09","markdown":"Notes_markdown__3fWWV"};